import { getfetchSites } from "./api.js";

/* ============================================================================
 * sitesCache — one /api/sites call per page load, shared by every component
 * that needs the site list (OnboardActive → OnboardingEditForm, etc.).
 *
 *   loadActiveSiteNames()        → Promise<string[]>   (cached after first call)
 *   loadActiveSiteNames(true)    → force a refetch (e.g. on ↻ refresh)
 *   peekActiveSiteNames()        → string[] | null     (sync, no fetch)
 * ==========================================================================*/

let cache = null;
let inflight = null;

const namesFrom = (res) =>
  res?.status === "success"
    ? (res.activeSites ?? []).map((s) => (s?.name ?? "").toString().trim()).filter(Boolean)
    : [];

export const loadActiveSiteNames = (force = false) => {
  if (cache && !force) return Promise.resolve(cache);
  if (inflight && !force) return inflight;
  inflight = getfetchSites()
    .then((res) => {
      cache = namesFrom(res);
      inflight = null;
      return cache;
    })
    .catch(() => {
      inflight = null;
      return cache ?? [];
    });
  return inflight;
};

export const peekActiveSiteNames = () => cache;